import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingLibraryCatalogue } from '@euler/model/coaching';
import { memo } from 'react';
import { Pressable, ScrollView } from 'react-native';
import { CollectionIllustration } from './CollectionIllustration';

type Collection = CoachingLibraryCatalogue['collections'][number];

/** The starter collections as a horizontal row of tiles. */
export const CollectionStrip = memo(
  ({
    collections,
    onOpen,
  }: {
    collections: Collection[];
    onOpen: (collection: Collection) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ gap: rpx(10), paddingBottom: rpx(4) }}
      >
        {collections.map(collection => (
          <Pressable
            key={collection.slug}
            onPress={() => onOpen(collection)}
            accessibilityRole="button"
            style={({ pressed }) => ({
              width: rpx(144),
              borderRadius: rpx(14),
              borderWidth: 1,
              borderColor: aiColors.border,
              backgroundColor: aiColors.card,
              padding: rpx(12),
              opacity: pressed ? 0.85 : 1,
            })}
          >
            <CollectionIllustration slug={collection.slug} size={rpx(48)} />
            <Typography.Text
              size={rpx(14)}
              bold
              color={aiColors.foreground}
              numberOfLines={1}
              style={{ marginTop: rpx(10) }}
            >
              {collection.name}
            </Typography.Text>
            <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
              {collection.caseCount} 个场景
            </Typography.Text>
          </Pressable>
        ))}
      </ScrollView>
    );
  },
);
